import styled from "styled-components";

export const TopLink = styled.span`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  transition: 0.3s ease;
  color: #9ca8b1;
  height: 100%;
  font-size: 24px;
  cursor: pointer;
  margin: 0 16px;

  &:hover {
    color: ${({ theme }) => theme["@primary"]};
  }
`;
